import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class MountainRoadTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MOUNTAIN_ROAD;
}

export default MountainRoadTileEntity;
